import React from 'react';

class NotFound extends React.Component {
  componentWillMount() {
    console.log(this);
  }
  render () {
    return (
      <div></div>
    )
  }
}

export default NotFound;



// WEBPACK FOOTER //
// ./src/components/Common/NotFound.js